var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content_box" },
    [
      _c(
        "v-snackbar",
        {
          attrs: { top: "", center: "", timeout: 10000, color: _vm.errorColor },
          model: {
            value: _vm.tokensApiFailed,
            callback: function($$v) {
              _vm.tokensApiFailed = $$v
            },
            expression: "tokensApiFailed"
          }
        },
        [
          _c("v-icon", { attrs: { dark: "" } }, [_vm._v("warning")]),
          _vm._v("   \n        "),
          _c("span", [_vm._v("Api failed")]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "black--text snackbar-button",
              attrs: { color: _vm.errorColor, flat: "" },
              on: {
                click: function($event) {
                  _vm.tokensApiFailed = null
                  _vm.tokensApiFailed = false
                }
              }
            },
            [_vm._v("Close")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "settings_panel_card", attrs: { flat: "" } },
        [
          _c(
            "v-toolbar",
            { staticClass: "settings_toolbar", attrs: { flat: "", dense: "" } },
            [
              _c("v-toolbar-title", { staticClass: "settings_panel_heading" }, [
                _vm._v("Access Tokens")
              ]),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c("textarea", {
                staticStyle: { opacity: "0" },
                attrs: { id: "unmasked_token_data", rows: "3" },
                domProps: { value: _vm.tokensInformation }
              }),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    color: "#736B63",
                    dark: "",
                    small: "",
                    depressed: ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.deleteEnableDisableTokens("", "", "generate")
                    }
                  }
                },
                [_vm._v("\n                generate\n            ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-layout",
            { staticClass: "access-token-sub-navigation", attrs: { wrap: "" } },
            [
              _c(
                "v-flex",
                { staticClass: "pl-3", attrs: { xs3: "", md4: "" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "access-token__icons",
                      attrs: { color: "purple" }
                    },
                    [_vm._v("\n                    person\n                ")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "app_token_in_tokens_page" }, [
                    _vm._v(_vm._s(_vm.userName))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs4: "", md4: "" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "access-token__icons",
                      attrs: { color: "purple" }
                    },
                    [_vm._v("\n                    vpn_key\n                ")]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "app_token_in_tokens_page" }, [
                    _vm._v(_vm._s(_vm._f("tokenMask")(_vm.userToken)))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                { attrs: { xs3: "", md3: "" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "access-token__icons",
                      attrs: { color: "purple" }
                    },
                    [
                      _vm._v(
                        "\n                    brightness_auto\n                "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "app_token_in_tokens_page" }, [
                    _vm._v(_vm._s(_vm._f("tokenMask")(_vm.apptoken)))
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-flex",
                {
                  staticStyle: { "text-align": "left" },
                  attrs: { xs1: "", md1: "" }
                },
                [
                  _vm.copiedContent
                    ? _c(
                        "v-icon",
                        {
                          staticClass: "access-token__icons",
                          attrs: { color: "purple" }
                        },
                        [_vm._v("\n                    done\n                ")]
                      )
                    : _c(
                        "v-icon",
                        {
                          staticClass: "access-token__icons",
                          attrs: { color: "purple" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.copyAppToken(_vm.apptoken, -1)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    content_copy\n                "
                          )
                        ]
                      )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "apps_tokens_table_div" }, [
            _c("table", { staticClass: "apps_component_table" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", [_vm._v("Access Token")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("last Used")]),
                  _vm._v(" "),
                  _c("th", [_vm._v("Actions")])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                [
                  _vm._l(_vm.tablesTokens, function(items, index) {
                    return _c("tr", { key: index }, [
                      items.alias == _vm.staredAlias
                        ? _c("td", { staticClass: "stared-td" }, [
                            _c("span", [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm._f("tokenMask")(_vm.staredAlias)) +
                                  "\n                            "
                              )
                            ])
                          ])
                        : _c("td", { staticClass: "alignment_for_data" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm._f("tokenMask")(items.alias)) +
                                "\n                        "
                            )
                          ]),
                      _vm._v(" "),
                      items.alias == _vm.staredAlias
                        ? _c("td", { staticClass: "stared-td" }, [
                            _vm._v(
                              "\n                            -\n                        "
                            )
                          ])
                        : _c("td", { staticClass: "alignment_for_data" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(items.lastTimeUsed) +
                                "\n                        "
                            )
                          ]),
                      _vm._v(" "),
                      items.alias == _vm.staredAlias
                        ? _c(
                            "td",
                            { staticClass: "stared-td" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  index == _vm.selectedIndex
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "access-token__icons"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        check_circle_outline\n                                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass:
                                                "access-token__icons ml-3",
                                              on: {
                                                click: function($event) {
                                                  return _vm.copyAppToken(
                                                    items.alias,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        content_copy\n                                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "i",
                                    {
                                      staticClass: "material-icons stars",
                                      attrs: { title: "Used internally" }
                                    },
                                    [_vm._v("star")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _c(
                            "td",
                            {
                              staticClass:
                                "alignment_for_data actions_allignments"
                            },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  index == _vm.selectedIndex
                                    ? _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass: "access-token__icons"
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        check_circle_outline\n                                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "v-flex",
                                        { attrs: { xs4: "" } },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              staticClass:
                                                "access-token__icons ml-3",
                                              on: {
                                                click: function($event) {
                                                  return _vm.copyAppToken(
                                                    items.alias,
                                                    index
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        content_copy\n                                    "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    { attrs: { xs4: "" } },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "access-token__icons",
                                          on: {
                                            click: function($event) {
                                              return _vm.deleteEnableDisableTokens(
                                                items,
                                                index,
                                                "delete"
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                        delete\n                                    "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-flex",
                                    {
                                      staticClass: "toggle-switch",
                                      attrs: { xs4: "" }
                                    },
                                    [
                                      _c("v-switch", {
                                        staticClass: "pa-0 ma-0 mr-1",
                                        attrs: {
                                          title: items.enabled
                                            ? "enabled"
                                            : "disabled",
                                          color: "blue"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteEnableDisableTokens(
                                              items.enabled,
                                              items,
                                              "enableDisable"
                                            )
                                          }
                                        },
                                        model: {
                                          value: items.enabled,
                                          callback: function($$v) {
                                            _vm.$set(items, "enabled", $$v)
                                          },
                                          expression: "items.enabled"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                    ])
                  }),
                  _vm._v(" "),
                  _vm.genarateToken
                    ? _c("tr", { attrs: { id: "new_token" } }, [
                        _c("td", [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.storeGenaratedAlias,
                                expression: "storeGenaratedAlias"
                              }
                            ],
                            staticClass: "token_genarate_input",
                            attrs: { type: "text" },
                            domProps: { value: _vm.storeGenaratedAlias },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.storeGenaratedAlias = $event.target.value
                              }
                            }
                          })
                        ]),
                        _vm._v(" "),
                        _c("td", [_vm._v("today")]),
                        _vm._v(" "),
                        _c("td", [
                          _c(
                            "i",
                            {
                              staticClass:
                                "material-icons check_circle_outline",
                              on: {
                                click: function($event) {
                                  return _vm.saveTokensDetails()
                                }
                              }
                            },
                            [_vm._v("check_circle_outline")]
                          )
                        ])
                      ])
                    : _vm._e()
                ],
                2
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }